import {
  project_call_delete_phase_path,
  project_call_management_phase_rows_path,
  project_call_phase_management_windows_path,
  project_call_unlock_window_changing_path,
  phase_management_call_details_path,
  project_call_update_phase_sort_order_path
} from '~/routes';

export const ActionJS_ProjectCall = {
	edit_evaluation_phase: function() {
		var dataIndex = 0;
		var options = {
	    deferRender: true,
	    data: jQuery('#select-evaluator-table').data('table-content'),
	    sorting: [[1, 'desc']],
	    lengthChange: false,
	    pageLength: 20,
	    autoWidth: false,
	    tabIndex: true,
		language: {
			searchPlaceholder: I18n.t('search')
		  },
	    columnDefs: [
	    	{
	    		type: "html", 
	      	render: function ( data, type, full, meta ) {
	      		var $cb = jQuery('<input>').attr('type', 'checkbox');
	      		$cb.attr('name', 'selected_evaluator['+data.project_id+']').attr('value', data.person_id);
	      		if (data.selected) {
	      			$cb.attr('checked', 'checked');
	      		}
	      		return jQuery('<div>').append($cb).html();
	      	},
	      	targets: jQuery('#select-evaluator-table').data('evaluator-columns')
	      }
	    ],
	    createdRow: function( row, data, dataIndex ) {
		    jQuery(row).attr('tabindex', 1);
		    jQuery(row).attr('data-index', dataIndex++);
		  }
	  };

	  var noteTable = jQuery('#select-evaluator-table').DataTable(options);

	  // selecting rows
	  // jQuery('#select-evaluator-table tbody tr').on('mousedown', function(e){

	  // 	if (!e.metaKey && !e.ctrlKey && !e.shiftKey) {
	  // 		jQuery('#select-evaluator-table tbody tr').removeClass('selected');
	  // 	}

	  // 	if (e.shiftKey) {
	  // 		var targetIndex = jQuery(e.currentTarget).data('index');
	  // 		if (targetIndex > jQuery('#select-evaluator-table tbody tr.focus').data('index')) {
		 //  		jQuery('#select-evaluator-table tbody tr.focus').nextUntil('[data-index="'+targetIndex+'"]').addClass('selected');
		 //  	}
		 //  	else {
		 //  		jQuery('#select-evaluator-table tbody tr.focus').prevUntil('[data-index="'+targetIndex+'"]').addClass('selected');	
		 //  	}
		 //  }

	  // 	jQuery('#select-evaluator-table tbody tr').removeClass('focus');
	  // 	jQuery(this).addClass('selected focus');
	  // });
	},


	phase_management: function () {
		// phase sorting
		$('#call-phase-row-container').sortable({
			items: '.call-phase-row:not(.disabled)',
			handle: '.call-phase-type-icon',
			axis: 'y',
			start: function (e, ui) { $(ui.item).addClass('phase-dragging') },
			stop: function (e, ui) { $(ui.item).removeClass('phase-dragging') },
			update: function () {
				ActionJS.ProjectCall.priv.savePhaseOrder();
			}
		});

		// Edit toggle
		jQuery('#call-phase-allow-editing.smartme-toggle').smartmeToggle();
		var toggleEditing = function() {
			var editable = jQuery('#call-phase-allow-editing').hasClass('yes');
			jQuery('#project-phase-management-form').toggleClass('editable', editable);
			jQuery('#call-phase-row-container').sortable(editable ? 'enable' : 'disable');
		};
		jQuery('#call-phase-allow-editing').on('click', toggleEditing);
		toggleEditing();

		// Add phases
		jQuery('.call-phase-insert').on('click', function() {
			var id = SmartME.generateUniqueId;
			var $row = jQuery(jQuery('#call-phase-row-template.'+jQuery(this).data('phase-type')).html().
				replace(new RegExp('randomId', 'g'), id));
			$row.find('.datetimepicker').flatpickr({
				dateFormat: "Y-m-d", 
				allowInput: true,
			});
			jQuery('#call-phase-row-container .call-phase-row:last').before($row);
			ActionJS.ProjectCall.priv.savePhaseOrder();
		})

		// Delete phase
		jQuery('#call-phase-row-container').delegate('.call-phase-remove', 'click', function() {
			if (confirm(I18n.t('confirm_delete_phase'))) {
				jQuery.ajax({
					url: project_call_delete_phase_path({format: null, phase_id: jQuery(this).data('phase-id')}),
					method: 'POST'
				}).error(function(){
					alert('Error occurred when deleting the phase.')
				}).done(function() {
					ActionJS.ProjectCall.priv.savePhaseOrder();
				});
				jQuery(this).closest('.call-phase-row').remove();
			}

			return false;
		});

		// Load windows-section
		ActionJS.ProjectCall.updateManagementWindowRows();

		// Click open-datepicker opens date input
		jQuery('.open-datepicker').on('click', function(){
			jQuery(this).closest('.input-group').find('.flatpickr-input').trigger("focus");
		})

		// results chain configuration

		jQuery('.override-fund-results-chain.smartme-toggle').smartmeToggle();
		jQuery('#override-fund-results-chain').on('change', function() {
			var isChecked = jQuery(this).prop('checked');
			jQuery('.result-chain-config').
				css('opacity', isChecked ? 1 : 0.5).
				find('input, select').prop('disabled', !isChecked);
		}).trigger('change');

		var onTopLevelChange = function() {
			var allLevels = jQuery('.result-chain-level-name');
			var hiddenLevels = jQuery('.result-chain-level-name[data-level="'+jQuery('#results_framework_config_first_level').val()+'"]').prevAll();

			// allLevels.find('input[type="text"]').removeAttr('disabled');
			allLevels.show();
			hiddenLevels.each(function() {
				// jQuery(this).find('input[type="text"]').attr('disabled', 'disabled');
				jQuery(this).hide();
			});
		};
		
		jQuery('body').delegate('#results_framework_config_first_level', 'change', onTopLevelChange);
		onTopLevelChange();

		jQuery('body').delegate('.result-chain-level-name input[type="text"]', 'change', function() {
			var newName = (jQuery('.result-chain-level-name input[type="text"]').index(this)+1) + '. ' + jQuery(this).val();
			jQuery('#results_framework_config_first_level option[value="'+jQuery(this).data('level')+'"]').text(newName);
		});
	},

	phase_management_save: function() {
		this.phase_management();
	},

	updateManagementPhaseRows: function(options) {
		if (typeof options === 'undefined') options = {};

		jQuery.ajax({
			url: project_call_management_phase_rows_path({
				format: null, call_id: jQuery('#call-phase-row-container').data('call-id')}),
			method: 'get'
		}).done(function(content) {
			jQuery('#call-phase-row-container').html(content);
			
			if (typeof options.afterUpdate !== 'undefined') {
				(options.afterUpdate)();
			}
		});
	},


	updateManagementWindowRows: function() {
		jQuery.ajax({
			url: project_call_phase_management_windows_path({
				format: null, call_id: jQuery('#call-window-container').data('call-id')}),
			method: 'get'
		}).done(function(content) {
			jQuery('#call-window-container').html(content);
			$('.lock-window-changing.smartme-toggle').smartmeToggle();
			jQuery('#lock-window-changing').off('change').on('change', function() {
				jQuery.ajax({
					url: project_call_unlock_window_changing_path({format: null, call_id: jQuery(this).closest('.lock-window-changing').data('call-id')}),
					method: 'post',
					data: {'unlock_window_changing': jQuery(this).is(':checked')}
				});
			});
		});
	},


	updateCallDetails: function() {
		jQuery.ajax({
			url: phase_management_call_details_path({
				format: null, call_id: jQuery('#call-window-container').data('call-id')}),
			method: 'get'
		}).done(function(content) {
			jQuery('#call-detail-container').html(content);
		});
	},


	priv: {
		savePhaseOrder: function() {
			$('[name="phases[][sort_order]"]').each(function(i,e){$(this).val(i+1);});
			
			jQuery.ajax({
				url: project_call_update_phase_sort_order_path({
					format: null, call_id: jQuery('#call-phase-row-container').data('call-id')}),
				method: 'post',
				data: {sort_order: jQuery('[name="phases[][id]"]').map(function(k,v){return jQuery(this).val()}).get()}
			}).error(function(resp) {
				alert('error saving sort order');
			});
		},


		initWindowTable: function() {
			jQuery('#phase-management-window-table').DataTable({
	      data: jQuery('#phase-management-window-table').data('table-data'),
	      pageLength: 15,
	      autoWidth: false,
	      lengthChange: false,
	      filter: false,
		  language: {
			searchPlaceholder: I18n.t('search')
		  },
	      columnDefs: [
	      	{
	      		sorting: false,
	      		targets: [0]
	      	}
	      ]
	    });
		}
	},

	edit_call: function() {
		alert();
		$('.smartme-toggle').smartmeToggle();
	},

};



var ProjectCall = {};

ProjectCall.ready = function() {
  $('.publish-decisions').each(function(item){
    $(this).off('click').on('click', function() {
      var link = $(this);
      status = link.data('decision-status');

      if (!confirm(link.data('confirm-text'))) {
        return false; 
      }
      $('#decision-publish-menu').html(SmartME.loadingIndicator(25));
      $.ajax({
        url: link.data('url'),
        type: 'post'
      }).done(function(resp) {
        $('#decision-publish-menu').replaceWith(resp);
        // Toggle published icons
        jQuery('.decision-cell .proceeding, .decision-cell .dropped').closest('.decision-cell').next().find('.unpublished').removeClass('unpublished').addClass('published').removeClass('fa-envelope-open').addClass('fa-envelope');
        jQuery('td .fa-envelope').attr('title', I18n.t('decision_published')).tooltip('fixTitle');

        // Refreshing data in ag-Grid version
        jQuery('#server-side-pagination-grid .ag-refresh').click();
        ProjectCall.ready();
      }).error(function(resp) {
        alert('error');
      });
    });
  })
};

window.ProjectCall = ProjectCall;